import config from 'config';
import IMAGEM from '../imagem';
import './style.css';

const Participantes = ({ nome, telefone, whatsup, foto, site, dados }) => {
  const hasPhone = telefone && telefone !== '';
  const hasWhatsapp = whatsup && whatsup !== '';

  return (
    <div className="participante-card" onClick={() => site(dados)}>
      <div className="participante-image-header">
        <IMAGEM 
          participantes={true}
          src={`${config.BASEIMG}${foto}`} 
          className="participante-img shadow-sm" 
          alt={nome} 
        />
      </div>
      <div className="participante-body">
        <h5 className="participante-title">{nome}</h5>
        <div className="participante-contact">
          {hasPhone && (
            <div className="contact-item">
              <i className="fas fa-phone-alt"></i>
              <span>{telefone}</span>
            </div>
          )}
          {hasWhatsapp && (
            <div className="contact-item">
              <i className="fab fa-whatsapp text-success"></i>
              <span>{whatsup}</span>
            </div>
          )}
          {!hasPhone && !hasWhatsapp && (
            <div className="contact-item opacity-50">
               <i className="fas fa-map-marker-alt"></i>
               <span>Ver no mapa</span>
            </div>
          )}
        </div>
      </div>
      <div className="participante-footer">
        <button className="btn-loja-detalhe">
          Ver detalhes <i className="fas fa-chevron-right ms-1"></i>
        </button>
      </div>
    </div>
  );
};


export default Participantes;
